import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const imageMap = [
  {
    image_black: "/assets/images/mist/vision-black-icon.png",
    image_white: "/assets/images/mist/vision-white-icon.png",
  },
  {
    image_black: "/assets/images/mist/mission-black-icon.png",
    image_white: "/assets/images/mist/mission-white-icon.png",
  },
  {
    image_black: "/assets/images/mist/value-black-icon.png",
    image_white: "/assets/images/mist/value-white-icon.png",
  },
];

function RevealBlocksVisionMissionValue({
  principles,
  siteType,
  defaultHeadings = ["Vision", "Mission", "Values"],
}) {


  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState({});
  const CHAR_LIMIT = 90;
  if (!principles?.length || siteType !== "hospitals") return null;


  const handleReadMore = (data) => {
    setSelectedContent(data);
    setShowModal(true);
  };

  const stripHtml = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const truncateWithReadMore = (html, data) => {
    const plainText = stripHtml(html);
    if (plainText.length <= CHAR_LIMIT) return html;

    const truncatedText = plainText.slice(0, CHAR_LIMIT);
    return `${truncatedText}... <span class="fw-bold" style="cursor:pointer;" onclick="window.__readMoreHandler('${data.heading}')">Read More</span>`;
  };

  // Expose handler globally
  window.__readMoreHandler = (heading) => {
    const matched = principles.find((item) => item.heading === heading);
    if (matched) handleReadMore(matched);
  };

  const carouselOptions = {
    items: 1,
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    margin: 15,
  };
  const isMobile = window.innerWidth < 768;

  const renderCard = (data, index) => {
    const imageSrc = isMobile
      ? imageMap[index]?.image_white  // mobile = always white
      : hoveredIndex === index
        ? imageMap[index]?.image_white  // desktop hover = white
        : imageMap[index]?.image_black; // desktop normal = black


    const displayText = truncateWithReadMore(
      data?.description || "No Description Found",
      data
    );

    return (
      <div
        className="s-feature-box text-center"
        onMouseEnter={() => !isMobile && setHoveredIndex(index)}
        onMouseLeave={() => !isMobile && setHoveredIndex(null)}
      >

        <div className="mask-top">
          <div className="feature-icon">
            <img
              src={imageSrc || "/assets/img/no-image.png"}
              alt=""
              style={{ width: "40px", height: "40px" }}
            />
          </div>
          <h4>{data?.heading || defaultHeadings[index]}</h4>
        </div>
        <div className="mask-bottom">
          <div className="feature-icon">
            <img
              src={imageSrc || "/assets/img/no-image.png"}
              alt=""
              style={{ width: "40px", height: "40px" }}
            />
          </div>
          <h4 className="mb-0">{data?.heading || defaultHeadings[index]}</h4>
          <p
            dangerouslySetInnerHTML={{
              __html: displayText,
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Desktop View */}
      <div
        id="flip-box-section"
        className="flip-box-section pad-bottom-md-none index-1 relative semi-dark home-intro-desktop mt-4"
      >
        <div className="container">
          <div className="row special-feature">
            {principles.map((data, index) => (
              <div key={`desktop-${index}`} className="col-md-4 mb-3 mb-lg-0 mt-4">
                {renderCard(data, index)}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile View */}
      <div className="home-intro-mobile-view mt-4">
        <div className="container">
          <OwlCarousel
            className="owl-theme special-feature"
            {...carouselOptions}
          >
            {principles.map((data, index) => (
              <div key={`mobile-${index}`} className="item">
                {renderCard(data, index)}
              </div>
            ))}
          </OwlCarousel>
        </div>
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedContent?.heading || "Details"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            dangerouslySetInnerHTML={{
              __html: selectedContent?.description || "No content available",
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-default" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RevealBlocksVisionMissionValue;
